var dsox = dsox || {};
dsox.Utilities = (function () {

	var windowDimensions = { 'width': 0, 'height': 0 };

	/**
	 * Get window dimensions
	 */
	var viewportDimensions = function ($) {
		windowDimensions.width = window.innerWidth;
		windowDimensions.height = window.innerHeight;
	}

	var addGTM = function ($) {
		var gtmButtons = $('.js-add-gtm');

		gtmButtons.each(function(){
			var $this = $(this);
			var currentPage = window.location.pathname;
			currentPage = currentPage.split("/");
			currentPage = currentPage.slice(-1)[0].replace("-", " ");
			currentPage = currentPage.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
			var $thisText = $this.text();
			var gtmValue = currentPage + " : " + $thisText;

			$this
				.attr('data-gtm-id', 'Button Click')
				.attr('data-gtm-value', gtmValue);
		});
	}

	var headerHeight = function ($) {
		var theHeight = $('.js-header').height();
		$('.js-main').css({paddingTop : theHeight});
	}

	var removeNBSP = function($) {
		//Removes &nbsp in-between anchor tags added by the wysiwyg editor
		if($('.js-anchor-list').length > 0){
			$('.js-anchor-list').html(function (i, html) {
				return html.replace(/&nbsp;/g, '');
			});
		}
	}

	var autoplayHeroVideo = function($) {
		var heroVideo = $('.hero-image');
		//get the iframe inside this slide.
		var player = heroVideo.find("iframe").get(0);
		var command = {
			"event": "command",
			"func": "playVideo"
		};

		setTimeout(function(){
			//check if the player exists.
			if (player !== undefined) {
				//post our command to the iframe.
				player.contentWindow.postMessage(JSON.stringify(command), "*");
			}
		}, 800)
	}

	var toggleMobileNavIcons = function($){
		$('.js-dropdown-toggle').on('click', function(){
			$('.nav-item.dropdown').each(function(){
				var navItem = $(this);
				if(navItem.hasClass('show')){
					navItem.find('[data-fa-i2svg]').addClass('fa-plus').removeClass('fa-minus');
				}
			});

			var navLink = $(this);
			if(navLink.parent().hasClass('show')){
				navLink.find('[data-fa-i2svg]').removeClass('fa-minus').addClass('fa-plus');
			} else {
				navLink.find('[data-fa-i2svg]').removeClass('fa-plus').addClass('fa-minus');
			}
		})
	}

	var toggleMobileHamburgerIcon = function($){
		$(document).on('click', '.navbar-toggler[aria-label="Toggle navigation"]', function(){
			$(this).find('[data-fa-i2svg]').toggleClass('fa-bars').toggleClass('fa-times');
			$('.nav-item.dropdown').find('[data-fa-i2svg]').removeClass('fa-minus').addClass('fa-plus');
			$('.js-header').toggleClass('mobile-open');
			$('body').toggleClass('mobile-open');
		})
	}

	var addCaretToTransparentButton = function($){
		$('.btn-link').each(function(){
			$(this).prepend('<i class="far fa-angle-right mr-2"></i>');
		})
	}

	var anchorTargetOffset = function($){
		$(document).on('click', 'a[href*="#"]:not(.js-filter-header)' , function(){
			var elementId = $(this).attr('href');
			
			if(elementId.length > 1){
				var offset = $(elementId).offset();
				var headerHeight = 240;
				
				if($(elementId).hasClass('js-visible')){
					headerHeight = 140;
				}
				
				var scrollTo = offset.top - headerHeight; // minus fixed header height
				$('html, body').animate({scrollTop:scrollTo}, 560);
			}
			
		})
	}

	var moveLabel = function($) {
		$(".form-control").on("focus", function() {
			$(this).siblings('.form-label').addClass("label-move");
		});

		$(".form-control").on("blur", function() {
			if(!$(this).val()) {
				$(this).siblings('.form-label').removeClass("label-move");
			}
		})
	}

	var acceptCookieConsent = function($) {
		var cookieConsent = getCookie("cookieConsent");
		if(cookieConsent !== "accepted") {
			$('.js-cookie-consent').show();
			$('.js-accept-cookie-consent').on('click', function(e){
				e.preventDefault();
				$('.js-cookie-consent').hide();
				document.cookie = "cookieConsent=accepted; path=/";
			})
		}

		//function getCookie        
		function getCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1);
				if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
			}
			return "";
		}
	}

	var disableRightClickOnImages = function($) {
		$("img").on("contextmenu",function(){
			return false;
		}); 
	}

	return {
		viewportDimensions : viewportDimensions,
		addGTM : addGTM,
		headerHeight : headerHeight,
		autoplayHeroVideo : autoplayHeroVideo,
		toggleMobileNavIcons : toggleMobileNavIcons,
		toggleMobileHamburgerIcon : toggleMobileHamburgerIcon,
		addCaretToTransparentButton : addCaretToTransparentButton,
		anchorTargetOffset : anchorTargetOffset,
		moveLabel : moveLabel,
		acceptCookieConsent : acceptCookieConsent,
		disableRightClickOnImages : disableRightClickOnImages,
		removeNBSP : removeNBSP
	}
}());